import LicenseResourceFlow from "@pathwright/web/src/modules/resource/license/LicenseResourceFlow"
import { createCardRoutes } from "lib/core/routing/card-routing"
import { getConversionRoute } from "lib/core/utils/urls"
import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import path from "path-browserify"
import { loadResource } from "path/middleware"

export default createCardRoutes(
  `/library/:resourceSlug/resource/license/`,
  {
    license: {
      path: ":licenseOfferingId(\\d+)/(thank-you)?/",
      middleware: (nextState) => loadResource(nextState),
      getDefaultLaunchedFrom: ({ location }) =>
        path.join(location.pathname, "../../../", "/about/"),
      component: ({ card, match, school }) => (
        <LicenseResourceFlow
          card={card}
          id={parseInt(match.params.licenseOfferingId)}
          licenseeSchool={school}
          onLicenseSuccess={(resourceLicense) => {
            App.navigate(getConversionRoute())
            App.getStore("resource").action.loadUserRegistrations(true)
          }}
        />
      )
    }
  },
  LibraryResourceContainer
)
